import { render, staticRenderFns } from "./movimento.vue?vue&type=template&id=553849b2"
import script from "./movimento.vue?vue&type=script&lang=js"
export * from "./movimento.vue?vue&type=script&lang=js"
import style0 from "./movimento.vue?vue&type=style&index=0&id=553849b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports